<template>
  <Swiper :swiperOptions="swiperOptions" :parentClass="swiperClass">
    <template v-if="filter !== 'Learning Paths'">
      <CourseTile
        v-for="item in content"
        :key="item.objectID"
        class="swiper-slide"
        :course="item"
        :backgroundImg="$getCourseBackground(item.objectID, 'small')"
        :link="$buildContentLink('course', item)"
        :gradient="$getGradient()"
        :duration="
          item.duration && item.duration.length
            ? $duration.getCourseDuration(item)
            : '0:00'
        "
        :difficulty="item.difficulty"
        :learningAreaName="learningAreaName"
        :customClass="`filtered-courses__content`"
        :isFreeTrialUser="isFreeTrialUser"
      />
    </template>
    <template v-else>
      <LearningPathTile
        v-for="item in content"
        class="swiper-slide"
        :key="item.objectID"
        :path="item"
        :customClass="`filtered-courses__content`"
      />
    </template>
  </Swiper>
</template>

<script>
import Swiper from '@/components/layout/Swiper.vue'
import CourseTile from '@/components/layout/CourseTile.vue'
import LearningPathTile from '@/components/layout/LearningPathTile.vue'

export default {
  name: 'FilteredCourses',
  components: {
    Swiper,
    CourseTile,
    LearningPathTile,
  },
  props: {
    filter: {
      type: String,
      required: true,
    },
    content: {
      type: Array,
      required: true,
    },
    learningAreaName: {
      type: String,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
    swiperClass: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        loop: false,
        freeMode: true,
      },
    }
  },
}
</script>

<style lang="scss">
.filtered-courses {
  &__content {
    width: 350px;
    .course-tile__details {
      height: 175px;
      width: 85%;
    }
    .path-tile__primary {
      height: 175px;
    }
  }
}
</style>
